import styled from "styled-components";

export const SubHeading = styled.h2`
  font-size: 1rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};
  background: rgb(63, 94, 251);
  background: linear-gradient(
    144deg,
    rgba(63, 94, 251, 1) 3%,
    rgba(252, 70, 107, 1) 100%
  );
  padding: 0.4rem;
`;


export const Timeline = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TimelineEvent = styled.div`
  display: flex;
  margin: 20px 0;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 2px;
    background-color: #ccc;
    margin-left: 6px;
  }
`;

export const TimelineEventContent = styled.div`
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  margin-left: 20px;
  flex: 1;
`;

export const TimelineEventTitle = styled.h3`
  margin: 0;
`;

export const TimelineEventDate = styled.p`
  margin: 0;
`;
